var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"#fff","d":"M4.5.5h15v23h-15z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }